import { IStudentProfilesListing, StudentProfilesListingModel } from './models/student_profiles_listing_model';

class StudentProfilesListing {
  private text: IStudentProfilesListing['text'];
  private url: IStudentProfilesListing['url'];
  private enabled: IStudentProfilesListing['enabled'];

  constructor(private ngStudentProfilesListingModel: StudentProfilesListingModel) {}

  navigateToUrl() {
    if (this.url) {
      window.location.assign(this.url);
    }
  }

  $onInit() {
    const details = this.ngStudentProfilesListingModel.read();
    this.text = details.text;
    this.url = details.url;
    this.enabled = details.enabled;
  }
}

angular.module('capability-ng-academic-planner').component('studentProfilesListing', {
  templateUrl:
    'capability-ng-academic-planner/src/advisor_header/components/student_profiles_listing/student_profiles_listing.html',
  controller: StudentProfilesListing
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/advisor_header/components/student_profiles_listing/student_profiles_listing.ts